var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaritacaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #1a3c34;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 216.75,
    y1: 124.97,
    x2: 364.43,
    y2: 461.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a3c34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a3c34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 288.57,
    y1: 617.22,
    x2: 193.84,
    y2: 187.35,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M535.68,480.1h-30.64v-134.61h30.07v35.51h2.58c7.44-25.2,24.34-38.95,47.25-38.95,25.2,0,37.8,15.47,39.81,40.38h3.15c6.59-25.78,22.34-40.38,47.26-40.38,28.35,0,42.1,18.9,42.1,48.11v89.93h-30.93v-81.91c0-16.32-7.45-28.35-25.49-28.35-21.19,0-34.37,13.75-34.37,34.08v76.18h-30.64v-81.91c0-16.32-7.73-28.35-25.77-28.35-20.62,0-34.37,13.75-34.37,34.08v76.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M804.01,342.34c-34.28,0-53.45,16.25-58.66,41.62h31.26c4.43-11.22,12.98-16.99,26.25-16.99,18.9,0,26.06,10.03,26.06,27.49v9.16h-40.1c-34.08,0-48.69,17.47-48.69,41.53,0,26.35,16.9,37.8,40.95,37.8s39.23-13.17,46.11-34.94h3.15v32.07h29.21v-85.92c0-33.51-16.61-51.84-55.56-51.84ZM828.93,429.41c0,16.9-14.32,29.5-35.8,29.5-17.47,0-23.48-8.31-23.48-18.05,0-11.17,8.88-16.9,24.34-16.9h34.94v5.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M890.78,480.1v-134.61h29.21v40.38l2.58.29c7.73-32.65,20.34-42.1,39.81-42.1h4.87v34.65h-7.44c-28.35,0-38.38,10.03-38.38,37.52v63.86h-30.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M988.72,322.58v-24.91h33.51v24.91h-33.51ZM989.86,480.1v-134.61h30.93v134.61h-30.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1385.33,433.72c-4.48,13.05-12.61,22.89-31.21,22.89-24.06,0-36.66-16.61-36.66-43.82,0-29.5,13.74-43.53,35.8-43.53,18.86,0,27.27,9.09,31.73,23.19h30.42c-5.45-32.07-22.92-50.4-61.58-50.4-41.24,0-67.88,26.63-67.88,71.88s26.06,69.88,68.45,69.88c36.94,0,55.84-18.9,61.29-50.1h-30.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1612.13,445.16v34.94h-35.8v-34.94h35.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1780.51,322.58v-24.91h33.51v24.91h-33.51ZM1781.66,480.1v-134.61h30.93v134.61h-30.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1056.86,309.13h30.93v27.55l-8.1,5.66v3.16h47.63v24.92h-39.53v64.44c0,13.18,4.87,20.05,18.33,20.05h23.2v28.93h-30.36c-29.5,0-42.1-19.47-42.1-44.68v-130.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1206.35,342.34c-34.28,0-53.45,16.25-58.66,41.62h31.26c4.43-11.22,12.98-16.99,26.25-16.99,18.9,0,26.06,10.03,26.06,27.49v9.16h-40.1c-34.08,0-48.69,17.47-48.69,41.53,0,26.35,16.9,37.8,40.95,37.8s39.23-13.17,46.11-34.94h3.15v32.07h29.21v-85.92c0-33.51-16.61-51.84-55.56-51.84ZM1231.27,429.41c0,16.9-14.32,29.5-35.8,29.5-17.47,0-23.48-8.31-23.48-18.05,0-11.17,8.88-16.9,24.34-16.9h34.94v5.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1496.44,342.34c-34.28,0-53.45,16.25-58.66,41.62h31.26c4.43-11.22,12.98-16.99,26.25-16.99,18.9,0,26.06,10.03,26.06,27.49v9.16h-40.1c-34.08,0-48.69,17.47-48.69,41.53,0,26.35,16.9,37.8,40.95,37.8s39.23-13.17,46.11-34.94h3.15v32.07h29.21v-85.92c0-33.51-16.61-51.84-55.56-51.84ZM1521.35,429.41c0,16.9-14.32,29.5-35.8,29.5-17.47,0-23.48-8.31-23.48-18.05,0-11.17,8.88-16.9,24.34-16.9h34.94v5.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1693.17,342.34c-34.28,0-53.45,16.25-58.66,41.62h31.26c4.43-11.22,12.98-16.99,26.25-16.99,18.9,0,26.06,10.03,26.06,27.49v9.16h-40.1c-34.08,0-48.69,17.47-48.69,41.53,0,26.35,16.9,37.8,40.95,37.8s39.23-13.17,46.11-34.94h3.15v32.07h29.21v-85.92c0-33.51-16.61-51.84-55.56-51.84ZM1718.09,429.41c0,16.9-14.32,29.5-35.8,29.5-17.47,0-23.48-8.31-23.48-18.05,0-11.17,8.88-16.9,24.34-16.9h34.94v5.44Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M365.21,408.77h65.06s-132.4-134.03-172.1-175.85c-6.88-7.25-18.5-6.61-24.76,1.19-12.67,15.78-20.33,35.27-21.56,55.76-1.65,27.52,8.41,54.66,27.6,74.46l115.75,116.86h82.54l-72.52-72.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.21,408.61l-31.02-31.31c-22.87-23.6-34.82-55.84-32.86-88.55,1.96-32.7,17.68-63.29,43.14-83.92,0,0,.04-.01.02-.07,9.24,1.54,18.95-.63,26.8-6.48-1.88-6.41-4.31-14.53-5.92-19.89-.58-1.94,1.58-3.54,3.26-2.41l30.78,20.56c8.1-16.32,5.83-36.44-6.86-50.6,2.66-4.87,1.72-11.62-4.1-15.06-13.06-7.72-31.79-14.71-57.13-14.71-43.86,0-117.34,39.81-117.34,137.59,0,56.28,36.16,121.59,102.71,145.55l-38.09,81.87h27.81l35-75.23c7.61,1.4,15.51,2.33,23.75,2.67l-33.76,72.57h27.81l24.89-53.5-18.89-19.07h0ZM234.61,134.08c6.1,0,11.04,4.94,11.04,11.04s-4.94,11.04-11.04,11.04-11.04-4.94-11.04-11.04,4.94-11.04,11.04-11.04Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaritacaLogo);
export default __webpack_public_path__ + "static/media/maritaca-logo.42125fefe8de61818d69c94741962562.svg";
export { ForwardRef as ReactComponent };